import { render, staticRenderFns } from "./QueueTable.vue?vue&type=template&id=4a99b7be&scoped=true"
import script from "./QueueTable.vue?vue&type=script&lang=js"
export * from "./QueueTable.vue?vue&type=script&lang=js"
import style0 from "./QueueTable.vue?vue&type=style&index=0&id=4a99b7be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a99b7be",
  null
  
)

export default component.exports